"use strict";
exports.__esModule = true;
exports.sendFieldExtensionMessage = exports.setupFieldExtension = exports.defaultSetupOption = exports.isPostDataErrorMessage = exports.isPostDataSuccessMessage = exports.isGetDefaultDataMessage = void 0;
function isGetDefaultDataMessage(e) {
    var _a;
    return ((_a = e.data) === null || _a === void 0 ? void 0 : _a.action) === "MICROCMS_GET_DEFAULT_DATA";
}
exports.isGetDefaultDataMessage = isGetDefaultDataMessage;
function isPostDataSuccessMessage(e) {
    var _a;
    return ((_a = e.data) === null || _a === void 0 ? void 0 : _a.action) === "MICROCMS_POST_DATA_SUCCESS";
}
exports.isPostDataSuccessMessage = isPostDataSuccessMessage;
function isPostDataErrorMessage(e) {
    var _a;
    return ((_a = e.data) === null || _a === void 0 ? void 0 : _a.action) === "MICROCMS_POST_DATA_FAILURE";
}
exports.isPostDataErrorMessage = isPostDataErrorMessage;
exports.defaultSetupOption = {
    width: "100%",
    height: 400,
    onDefaultData: function (message) { return console.log("microCMS iframe on default data", message); },
    onPostSuccess: function (message) { return console.log("microCMS iframe on post success", message); },
    onPostError: function (message) { return console.error("microCMS iframe on post error", message); }
};
function setupFieldExtension(option) {
    var opt = Object.assign({}, exports.defaultSetupOption, option);
    var listener = function (e) {
        if (!e.isTrusted)
            return;
        if (e.origin !== opt.origin && opt.origin !== "*")
            return;
        if (isGetDefaultDataMessage(e)) {
            var updateStyleMessage = {
                id: e.data.id,
                action: "MICROCMS_UPDATE_STYLE",
                message: {
                    height: opt.height,
                    width: opt.width
                }
            };
            window.parent.postMessage(updateStyleMessage, opt.origin);
            opt.onDefaultData(e);
        }
        if (isPostDataSuccessMessage(e)) {
            opt.onPostSuccess(e);
        }
        if (isPostDataErrorMessage(e)) {
            opt.onPostError(e);
        }
    };
    window.addEventListener("message", listener);
    return function () { return window.removeEventListener("message", listener); };
}
exports.setupFieldExtension = setupFieldExtension;
function sendFieldExtensionMessage(message, origin) {
    var msg = Object.assign({}, message, {
        action: "MICROCMS_POST_DATA"
    });
    window.parent.postMessage(msg, origin);
}
exports.sendFieldExtensionMessage = sendFieldExtensionMessage;
